import React, {FC} from 'react';
import classNames from 'classnames';
import DynamicAsset from 'components/DynamicAsset';
import {navigate} from 'gatsby';

import * as styles from './styles.module.scss';

type TextOverImageItemProps = {
    imageSrc: string
    text: string
    link: string
}

const TextOverImageItem: FC<TextOverImageItemProps> = ({imageSrc, text, link}) => {
	const click = link && link.trim() !== '';
	const onClick = () => {
		if (click) {
			navigate(link);
		}
	};

	return (
		<div className={classNames({
			[styles.item]: true,
			[styles.click]: click,
		})} onClick={onClick}>
			<DynamicAsset
				imageSrc={imageSrc}
				className={styles.image}
			/>
			<div className={styles.text}>
				{text}
			</div>
		</div>
	);
};

export default TextOverImageItem;
